import {
  LoginPage,
  SignupPage,
  NotFound,
  ConfirmSignup,
  ForgotPassword,
  ConfirmNewPass,
  ConfirmForgotPassword,
  Account,
  LoginNewAccount,
  ProcessingStreamList,
  StreamDetail,
  CreateStream,
  OrgHome,
  HistoryStreamList,
  MemberList,
  Pricing,
  Activation,
  Unconfirmation,
  CreateOrganization,
} from "Pages";

export const PUBLIC_ROUTER = [
  {
    key: "login",
    path: "/login",
    element: <LoginPage />,
  },
  {
    key: "signup",
    path: "/sign-up",
    element: <SignupPage />,
  },
  {
    key: "activation",
    path: "/activation",
    element: <Activation />,
  },
  {
    key: "unconfirmation",
    path: "/unconfirmation",
    element: <Unconfirmation />,
  },
  {
    key: "not-found",
    path: "*",
    element: <NotFound />,
  },
  {
    key: "confirm",
    path: "/confirm/:customerId/:key",
    element: <ConfirmSignup />,
  },
  {
    key: "forgotPassword",
    path: "/forgotPassword",
    element: <ForgotPassword />,
  },
  {
    key: "confirmNewPass",
    path: "/confirmNewPass",
    element: <ConfirmNewPass />,
  },
  {
    key: "confirm-forgot-password",
    path: "/confirm-forgot-password/:customerId/:key",
    element: <ConfirmForgotPassword />,
  },
  {
    key: "login-new-acc",
    path: "/login-new-account",
    element: <LoginNewAccount />,
  },
];

export const PRIVATE_ROUTER = [
  {
    key: "home",
    path: "/",
    navKey: "home",
    element: <OrgHome />,
  },
  {
    key: "my-account",
    path: "/my-account",
    navKey: "account",
    element: <Account />,
  },
  {
    key: "proposal-list",
    path: "/proposal-list",
    navKey: "home",
    subNavKey: "proposal_list",
    element: <ProcessingStreamList />,
  },
  {
    key: "all-org-proposal-list",
    path: "/all-org-proposal-list",
    navKey: "home",
    subNavKey: "all_proposal_list",
    element: <ProcessingStreamList getAll />,
  },
  {
    key: "proposal-history",
    path: "/proposal-list/history",
    navKey: "home",
    subNavKey: "proposal_list",
    subSubNavKey: "proposal_history",
    element: <HistoryStreamList />,
  },
  {
    key: "all-org-proposal-history",
    path: "/all-org-proposal-list/history",
    navKey: "home",
    subNavKey: "all_proposal_list",
    element: <HistoryStreamList getAll />,
  },
  {
    key: "request-list",
    path: "/request-list",
    navKey: "home",
    subNavKey: "request_list",
    element: <ProcessingStreamList />,
  },
  {
    key: "all-org-request-list",
    path: "/all-org-request-list",
    navKey: "home",
    subNavKey: "all_request_list",
    element: <ProcessingStreamList getAll />,
  },
  {
    key: "request-history",
    path: "/request-list/history",
    navKey: "home",
    subNavKey: "request_list",
    subSubNavKey: "request_history",
    element: <HistoryStreamList />,
  },
  {
    key: "all-org-request-history",
    path: "/all-org-request-list/history",
    navKey: "home",
    subNavKey: "all_request_list",
    element: <HistoryStreamList getAll />,
  },
  {
    key: "task-list",
    path: "/task-list",
    navKey: "home",
    subNavKey: "task_list",
    element: <ProcessingStreamList />,
  },
  {
    key: "all-org-task-list",
    path: "/all-org-task-list",
    navKey: "home",
    subNavKey: "all_task_list",
    element: <ProcessingStreamList getAll />,
  },
  {
    key: "task-history",
    path: "/task-list/history",
    navKey: "home",
    subNavKey: "task_list",
    subSubNavKey: "task_history",
    element: <HistoryStreamList />,
  },
  {
    key: "all-org-task-history",
    path: "/all-org-task-list/history",
    navKey: "home",
    subNavKey: "all_task_list",
    element: <HistoryStreamList getAll />,
  },
  {
    key: "proposal-detail",
    path: "/proposal-detail/:streamId",
    navKey: "home",
    subNavKey: "proposal_list",
    subSubNavKey: "proposal_detail",
    element: <StreamDetail />,
  },
  {
    key: "request-detail",
    path: "/request-detail/:streamId",
    navKey: "home",
    subNavKey: "request_list",
    subSubNavKey: "request_detail",
    element: <StreamDetail />,
  },
  {
    key: "task-detail",
    path: "/task-detail/:streamId",
    navKey: "home",
    subNavKey: "task_list",
    subSubNavKey: "task_detail",
    element: <StreamDetail />,
  },
  {
    key: "create-stream",
    path: "/create-stream",
    navKey: "home",
    subNavKey: "create_stream",
    element: <CreateStream />,
  },
  {
    key: "member-list",
    path: "/member-list",
    navKey: "home",
    subNavKey: "member_list",
    element: <MemberList />,
  },
  {
    key: "pricing",
    path: "/pricing",
    navKey: "home",
    subNavKey: "pricing",
    element: <Pricing />,
  },
  {
    key: "create-organization",
    path: "/create-organization",
    navKey: "home",
    subNavKey: "create_organization",
    element: <CreateOrganization />,
  },
];
